import { Loader2, PackageOpen, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Loading = ({ label = "Loading…" }) => (
  <div data-testid="loading-state" className="flex items-center justify-center gap-2 py-20 text-slate-500">
    <Loader2 className="h-5 w-5 animate-spin text-blue-600" /> <span className="text-sm">{label}</span>
  </div>
);

export const Empty = ({ title, body, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center text-center py-16 px-6">
    <div className="h-14 w-14 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center mb-4">
      <PackageOpen className="h-7 w-7" />
    </div>
    <h3 className="font-bold text-slate-900">{title}</h3>
    {body && <p className="text-sm text-slate-500 mt-1 max-w-sm">{body}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div data-testid="error-state" className="flex flex-col items-center text-center py-16 px-6">
    <AlertTriangle className="h-8 w-8 text-red-500 mb-3" />
    <p className="text-sm text-slate-700 max-w-sm">{message}</p>
    {onRetry && (
      <Button data-testid="error-retry-btn" variant="outline" className="mt-4 rounded-xl" onClick={onRetry}>
        Try again
      </Button>
    )}
  </div>
);

export const PageTitle = ({ children, sub, right }) => (
  <div className="flex items-end justify-between gap-4 mb-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{children}</h1>
      {sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}
    </div>
    {right}
  </div>
);

export const StatusPill = ({ status }) => {
  const map = {
    active: "bg-emerald-50 text-emerald-700 border-emerald-200",
    reserved: "bg-amber-50 text-amber-800 border-amber-200",
    paused: "bg-slate-100 text-slate-600 border-slate-200",
    sold: "bg-slate-900 text-white border-slate-900",
    archived: "bg-slate-100 text-slate-500 border-slate-200",
  };
  return (
    <span data-testid={`status-pill-${status}`} className={`text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full border ${map[status] || map.paused}`}>
      {status}
    </span>
  );
};

export const Avatar = ({ user, size = 40 }) => {
  const style = { width: size, height: size };
  if (user?.photo) {
    return <img alt="" src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${user.photo}`} style={style} className="rounded-full object-cover bg-slate-100" />;
  }
  return (
    <div style={style} className="rounded-full bg-slate-900 text-white flex items-center justify-center font-bold" aria-hidden>
      <span style={{ fontSize: size * 0.4 }}>{(user?.first_name || "?")[0].toUpperCase()}</span>
    </div>
  );
};
